const theme = {
  colors: {
    primary: '#516C4D',
  },
};

export default theme;
